import React, { useState, useEffect } from "react";
import "./Dashboard.css";
import "chartjs-adapter-date-fns";
import UserDashboard from "./UserDashboard/UserDashboard";
import AdminDashboard from "./AdminDashboard/AdminDashboard";

function Dashboard() {
  // Declare all hooks at the top of the component
  const [userData, setUserData] = useState(null);
  const [error, setError] = useState(null);

  // Fetch user data from the backend
  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_FLASK_API_URL}/dashboard`, {
      method: "GET",
      credentials: "include",
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.error) {
          console.error(data.error);
          setError(data.error);
        } else {
          setUserData(data);
        }
      })
      .catch((error) => {
        console.error("Error fetching user data:", error);
        setError("Error fetching user data");
      });
  }, []);

  // If there is an error, display it
  if (error) {
    return <div>{error}</div>;
  }

  if (!userData) {
    return <div>Loading...</div>; // or null
  }

  return (
    <div className="dashboard">
      {userData.role_title === "Admin" ? (
        <AdminDashboard userData={userData} />
      ) : (
        <UserDashboard userData={userData} />
      )}
    </div>
  );
}

export default Dashboard;
